<template>
    <div class="main">
        <myheader></myheader>
        <div class="mains flex">
            <myleft></myleft>
            <div class="right">
                <div class="top title">材料检测委托合同</div>
                <div class="bot hetong">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="contract">
                        <el-form-item label="委托编号：" prop="serial">
                            <el-input v-model="ruleForm.serial"></el-input>
                        </el-form-item>
                        <el-form-item label="委托单位：" prop="entrust_id">
                            <el-col :span="10">
                                <el-form-item>
                                    <el-select v-model="ruleForm.entrust_id" placeholder="请选择" style="width: 100%;" @change="entrustidChange">
                                        <el-option v-for="(item,index) in entrustidList" :key="index" :label="item.name" :value="item.id"></el-option>
                                        <!-- <el-option label="宁波道路管理局" value="shanghai"></el-option>
                                        <el-option label="宁波艾琪" value="beijing"></el-option> -->
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="14">
                                <el-form-item label="委托人/电话：" prop="entrust_phone">
                                    <el-input v-model="ruleForm.entrust_phone" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="施工单位：" prop="construction_unit">
                            <el-input v-model="ruleForm.construction_unit"></el-input>
                        </el-form-item>
                        <el-form-item label="工程名称：" prop="project_name">
                            <el-input v-model="ruleForm.project_name"></el-input>
                        </el-form-item>
                        <el-form-item label="建设单位：" prop="build_unit">
                            <el-input v-model="ruleForm.build_unit"></el-input>
                        </el-form-item>
                        <el-form-item label="EPC单位：" prop="epc_unit">
                            <el-input v-model="ruleForm.epc_unit"></el-input>
                        </el-form-item>
                        <el-form-item label="见证单位：" prop="witness_unit">
                            <el-col :span="10">
                                <el-form-item>
                                    <el-input v-model="ruleForm.witness_unit" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="14">
                                <el-form-item label="见证人/电话：" prop="witness_phone">
                                    <el-input v-model="ruleForm.witness_phone" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="检测类别：" prop="detection_category">
                            <el-col :span="10">
                                <el-form-item>
                                    <el-radio-group v-model="ruleForm.detection_category" @change="detectionCategory">
                                        
                                        <el-radio label="0">委托检测</el-radio>
                                        <el-radio label="1">见证检测</el-radio>
                                        <el-radio label="2">其他</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="14">
                                <el-form-item label="委托日期：" prop="entrust_time">
                                    <el-date-picker v-model="ruleForm.entrust_time" value-format="timestamp" placeholder="请选择" style="width: 100%;"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <div class="hetong-title">委托内容</div>

                        <el-form-item label="样品编号：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_bianhao1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_bianhao2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_bianhao3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="样品名称：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_mingcheng1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_mingcheng2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_mingcheng3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="规格/牌号/设计强度：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_guige1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_guige2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_guige3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="出厂日期：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_date1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_date2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_date3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="出产编号/质保单号：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_ccbianhao1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_ccbianhao2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_ccbianhao3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="生产（供应）单位：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_danwei1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_danwei2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_danwei3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="批号（炉号）：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_pihao1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_pihao2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_pihao3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="现场桩号或结构部位：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_zhaunghao1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_zhaunghao2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_zhaunghao3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="取样/成型日期和龄期：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_quyang1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_quyang2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_quyang3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="养护条件：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_tiaojian1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_tiaojian2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_tiaojian3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="样品数量：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_shuliang1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_shuliang2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_shuliang3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="代表数量：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_dbshuliang1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_dbshuliang2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_dbshuliang3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="样品描述：">
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_miaoshu1" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_miaoshu2" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col style="width: 6.249995%;">
                                <el-input style="visibility: hidden;width: 100%;"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item>
                                    <el-input v-model="ruleForm.wt_miaoshu3" style="width: 100%;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>

                        <!-- 有子级弄不出来 -->
                        <!-- <el-form-item label="检测项目：" prop="entrust_project">
                            <el-checkbox-group v-model="ruleForm.entrust_project" @change="entrustProjectCheckbox">
                                <el-checkbox v-for="list1 in entrustProjectList" :key="list1.id" :value="list1.id" :label="list1.name">{{ list1.name }}
                                    <div v-if="list1.son.length > 0" style="display: inline-block;">(</div>
                                    <el-radio-group v-for="list2 in list1.son" :key="list2.id" v-model="ruleForm.entrust_project" @change="entrustProjectRadio" class="project">
                                        <el-radio :value="list2.id" :label="list2.price" :name="list2.name">{{ list2.name }}</el-radio>)
                                    </el-radio-group>
                                    <div v-if="list1.son.length > 0" style="display: inline-block;">)</div>
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item> -->
                        <el-form-item label="检测项目：" prop="entrust_project">
                            <el-checkbox-group v-model="ruleForm.entrust_project" @change="entrustProjectCheckbox">
                                <el-checkbox @change="project(item.id)" v-for="item in entrustProjectList" :key="item.id" :value="item.id" :label="item.price" :data-id="item.id">{{ item.name }} </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>

                        <el-form-item label="检测依据/评定标准：" prop="entrust_basis">
                            <el-checkbox-group v-model="ruleForm.entrust_basis" @change="changeCheckbox">
                                <el-checkbox v-for="item in basisList" :key="item.id" :value="item.id" :label="item.id" :data-id="item.id">{{ item.name }}</el-checkbox>
                                <!-- <el-checkbox label="30.00">现场测试规程 JTG3450-2019</el-checkbox>
                                <el-checkbox label="120.00">其它</el-checkbox> -->
                                <!-- <el-input v-model="ruleForm.basisId"></el-input> -->
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="附件说明：" prop="attachment">
                            <el-upload ref="upload" class="upload-demo" drag action="https://qdpc.jhwl.ink/api/quote/uploadImage" :file-list="ruleForm.attachment" :on-change="handleChange" :on-success="handleSuccess" :on-remove="handleRemove" accept=".xls, .xlsx">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">（点击上传附件）</div>
                                <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
                            </el-upload>
                        </el-form-item>
                        <div class="hetong-title">客户要求</div>
                        <el-form-item label="报告份数要求：" class="yaoqiu" prop="report_number">
                            <el-col :span="8">
                                <el-form-item>
                                    <el-radio-group v-model="ruleForm.report_number" @change="reportNumber">
                                        <el-radio label="0">按本单位规定,2份</el-radio>
                                        <el-radio label="1">其他</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="16">
                                <el-form-item label="报告发放要求：" prop="report_issue">
                                    <el-radio-group v-model="ruleForm.report_issue" @change="reportIssue">
                                        <el-radio label="0">自行取回/邮寄</el-radio>
                                        <el-radio label="1">其他</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="检测要求：" prop="report_detection">
                            <el-col :span="8">
                                <el-form-item>
                                    <el-radio-group v-model="ruleForm.report_detection" @change="reportDetection">
                                        <el-radio label="0">按本单位时限规定</el-radio>
                                        <el-radio label="1">其他</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="16">
                                <el-form-item label="样品处置要求：" prop="report_disposal">
                                    <el-radio-group v-model="ruleForm.report_disposal" class="chuzhi" @change="reportDisposal">
                                        <el-radio label="0">按本公司样品管理规定处理</el-radio>
                                        <el-radio label="1">检后天取回</el-radio>
                                        <el-radio label="2">其他</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="检测费：" prop="testing_fee">
                            <el-input v-model="ruleForm.testing_fee" autosize readonly></el-input>
                        </el-form-item>
                        <el-form-item label="声明：" prop="declaration">
                            <el-input type="textarea" v-model="ruleForm.declaration" autosize resize="none"></el-input>
                        </el-form-item>
                        <el-form-item label="公司信息：" prop="corporate">
                            <el-input type="textarea" v-model="ruleForm.corporate" autosize resize="none"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disabledHetong">保存检测委托合同</el-button>
                            <el-button type="primary" @click="resetForm('ruleForm')" :disabled="disabledRenwu">生成检测任务单</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
  </template>

<script>
    import {
        basis_gist_index,
        contract_entrust_add,
        basis_entrust_index,
        basis_project_index,
        basis_project_details,
        basis_project_channel
    } from "@/api";
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
    export default {
        data() {
            return {
                arr1: [],
                arr2: [],
                arr3: [],
                arr4: [],
                arr5: '',
                arr6: [],
                // 禁用按钮
                disabledHetong: false, // 生成和他按钮
                disabledRenwu: true, // 生成检测单按钮
                // 附件说明
                ruleForm: {
                    serial: '',
                    entrust_id: '',
                    entrust_phone: '',
                    construction_unit: '',
                    project_name: '',
                    build_unit: '',
                    epc_unit: '',
                    witness_unit: '',
                    witness_phone: '',
                    detection_category: '',
                    entrust_time: '',
                    entrust_content: [],
                    entrust_project: [],
                    entrust_basis: [],
                    //   basisId: '',
                    attachment: [],
                    report_number: '',
                    report_issue: '',
                    report_detection: '',
                    report_disposal: '',
                    testing_fee: 0,
                    declaration: '文字内容：①委托方对其所填写的委托信息内容的真实性和正确性负责；②对于非本公司负责抽样，或是由本公司抽样，但抽样方法和抽样计划的全部或部分内容 (如抽样地点、位置等) 由委托方指定时，本公司的检测结果仅对样品负责；③本公司对有条件、有备样意义和作用的样品均予以备样，请客户在委托检验的同时提供足够数量的试样以供备样；对各种砼试件 (除基桩钻芯试件) 、砂浆、水泥浆试件、稳定层试件、金属材料、土压实度试件、软基钻芯土样、水泥搅拌桩等复合地基钻芯芯样等样品，因其备样成本较高或备样难度较大不易备样的，不予备样；④本公司将按与客户的约定和公司的有关规定备样、留样、保管和处置检后样品，对超过约定或规定留样期限的检后样品，本公司将不负保管或提供备样的责任。',
                    corporate: '公司地址：宁波市镇海区中官路 1188 号 4 号楼    邮编：315200    电话 0574-55865977    传真：0574-55865977'
                },
                rules: {
                    serial: [{
                        required: true,
                        message: '请输入委托编号',
                        trigger: 'blur'
                    }],
                    entrust_id: [{
                        required: true,
                        message: '请选择委托单位',
                        trigger: 'blur'
                    }],
                    entrust_phone: [{
                        required: true,
                        message: '请输入委托人/电话',
                        trigger: 'blur'
                    }],
                    construction_unit: [{
                        required: true,
                        message: '请输入施工单位',
                        trigger: 'change'
                    }],
                    project_name: [{
                        required: true,
                        message: '请输入工程名称',
                        trigger: 'blur'
                    }],
                    build_unit: [{
                        required: true,
                        message: '请输入建设单位',
                        trigger: 'blur'
                    }],
                    epc_unit: [{
                        required: true,
                        message: '请输入EPC单位',
                        trigger: 'blur'
                    }],
                    witness_unit: [{
                        required: true,
                        message: '请输入见证单位',
                        trigger: 'blur'
                    }],
                    witness_phone: [{
                        required: true,
                        message: '请输入见证人/电话',
                        trigger: 'blur'
                    }],
                    detection_category: [{
                        required: true,
                        message: '请选择检测类别',
                        trigger: 'blur'
                    }],
                    entrust_time: [{
                        required: true,
                        message: '请选择委托日期',
                        trigger: 'blur'
                    }],
                    entrust_project: [{
                        required: true,
                        message: '请选择检测项目',
                        trigger: 'blur'
                    }],
                    entrust_basis: [{
                        required: true,
                        message: '请选择检测依据',
                        trigger: 'blur'
                    }],
                    attachment: [{
                        required: true,
                        message: '请上传附件',
                        trigger: 'blur'
                    }],
                    report_number: [{
                        required: true,
                        message: '请选择报告份数要求',
                        trigger: 'blur'
                    }],
                    report_issue: [{
                        required: true,
                        message: '请选择报告发放要求',
                        trigger: 'blur'
                    }],
                    report_detection: [{
                        required: true,
                        message: '请选择检测要求',
                        trigger: 'blur'
                    }],
                    report_disposal: [{
                        required: true,
                        message: '请选择样品处置要求',
                        trigger: 'blur'
                    }]
                },
                // 检测项目列表
                entrustProjectList: [],
                // 检测依据列表
                basisList: [],
                // 委托单位列表
                entrustidList: []
            }
        },
        components: {
            myheader: myheader,
            myleft: myleft
        },
        methods: {
            // 委托单位列表
            entrustId() {
                this.loading = true;
                basis_entrust_index().then((res) => {
                    // console.log(res.data.data.data);
                    this.loading = false;
                    if (res.data.code == 1) {
                        this.entrustidList = res.data.data.data;
                    }
                });
            },
            entrustidChange(val) {
                console.log(val);
                this.form.entrust_id = val
            },
            // 检测项目列表
            basisProjectChannel() {
                this.loading = true;
                basis_project_channel({
                    params: {
                        type: 'material'
                    }
                }).then((res) => {
                    //   console.log(res);
                    this.loading = false;
                    if (res.data.code == 1) {
                        this.entrustProjectList = res.data.data;
                    }
                });
            },
            entrustProjectCheckbox(val) {
                console.log(val.join(','));
                this.arr5 = val;
                console.log(this.arr5);
                // 计算检测费用  
                let sum = 0;
                for (let i = 0; i < this.arr5.length; i++) {
                    sum += parseFloat(this.arr5[i])
                };
                //   console.log("费用=" + sum);
                this.ruleForm.testing_fee = sum.toFixed(2);
                //   this.ruleForm.testing_fee = val.join(',');
                console.log(val)
            },
            // 检测项目价格
            project(id) {
                console.log(id);
                this.arr4.push(id);
                this.arr5 = this.arr4.join(',');
                console.log(this.ruleForm.entrust_project);
                console.log(this.arr4);
                console.log(this.arr5);

            },
            entrustProjectRadio(val) {
                console.log(val)
            },
            // 检测依据列表
            entrustBasis() {
                this.loading = true;
                basis_gist_index().then((res) => {
                    // console.log(res.data.data.data);
                    this.loading = false;
                    if (res.data.code == 1) {
                        this.basisList = res.data.data.data;
                    }
                });
            },
            // 上传附件
            handleSuccess(file) {
                console.log(file);
                if (file.code == 0) {
                    this.$message.error(file.msg);
                    this.$refs.upload.clearFiles(); // 格式不正确清除文件列表
                } else {
                    this.ruleForm.attachment = file.data.fullurl; // 已上传的文件赋值
                    this.$refs['ruleForm'].validateField('attachment'); // 上传成功清除上一步attachment的验证消息
                }
                console.log(file.data.fullurl)
            },
            // 文件改变
            handleChange(file, fileList) {
                console.log(file, fileList);
                if (fileList.length > 1) {
                    fileList.splice(0, 1); // 替换已上传的文件
                }
            },
            // 移除已上传的文件
            handleRemove(file, fileList) {
                console.log(file, fileList);
                this.ruleForm.attachment = ''
            },
            // 检测依据/评定标准
            changeCheckbox(val) {
                console.log(val);
                //   this.ruleForm.basisId = val.join(',');
                //   console.log(this.ruleForm.basisId)
            },
            //   project(id){
            //       console.log(id);
            //       this.arr4.push(id);
            //       console.log(this.arr4.join(','));
            //       this.ruleForm.entrust_basis = this.arr4.join(',');
            //       console.log(this.ruleForm.entrust_basis)
            //   },
            // 检测类别
            detectionCategory(val) {
                console.log(val);
                this.ruleForm.detection_category = val
            },
            // 报告份数要求
            reportNumber(val) {
                console.log(val);
                this.ruleForm.report_number = val
            },
            // 报告发放要求
            reportIssue(val) {
                console.log(val);
                this.ruleForm.report_issue = val
            },
            // 检测要求
            reportDetection(val) {
                console.log(val);
                this.ruleForm.report_detection = val
            },
            // 样品处置要求
            reportDisposal(val) {
                console.log(val);
                this.ruleForm.report_disposal = val
            },
            // 保存合同
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // console.log(this.form.name, this.form.type, this.form.price, this.form.pid);
                        this.arr1 = {
                            wt_bianhao1: this.ruleForm.wt_bianhao1,
                            wt_mingcheng1: this.ruleForm.wt_mingcheng1,
                            wt_guige1: this.ruleForm.wt_guige1,
                            wt_date1: this.ruleForm.wt_date1,
                            wt_ccbianhao1: this.ruleForm.wt_ccbianhao1,
                            wt_danwei1: this.ruleForm.wt_danwei1,
                            wt_pihao1: this.ruleForm.wt_pihao1,
                            wt_zhaunghao1: this.ruleForm.wt_zhaunghao1,
                            wt_quyang1: this.ruleForm.wt_quyang1,
                            wt_tiaojian1: this.ruleForm.wt_tiaojian1,
                            wt_shuliang1: this.ruleForm.wt_shuliang1,
                            wt_dbshuliang1: this.ruleForm.wt_dbshuliang1,
                            wt_miaoshu1: this.ruleForm.wt_miaoshu1
                        };
                        this.arr2 = {
                            wt_bianhao2: this.ruleForm.wt_bianhao2,
                            wt_mingcheng2: this.ruleForm.wt_mingcheng2,
                            wt_guige2: this.ruleForm.wt_guige2,
                            wt_date2: this.ruleForm.wt_date2,
                            wt_ccbianhao2: this.ruleForm.wt_ccbianhao2,
                            wt_danwei2: this.ruleForm.wt_danwei2,
                            wt_pihao2: this.ruleForm.wt_pihao2,
                            wt_zhaunghao2: this.ruleForm.wt_zhaunghao2,
                            wt_quyang2: this.ruleForm.wt_quyang2,
                            wt_tiaojian2: this.ruleForm.wt_tiaojian2,
                            wt_shuliang2: this.ruleForm.wt_shuliang2,
                            wt_dbshuliang2: this.ruleForm.wt_dbshuliang2,
                            wt_miaoshu2: this.ruleForm.wt_miaoshu2
                        };
                        this.arr3 = {
                            wt_bianhao3: this.ruleForm.wt_bianhao3,
                            wt_mingcheng3: this.ruleForm.wt_mingcheng3,
                            wt_guige3: this.ruleForm.wt_guige3,
                            wt_date3: this.ruleForm.wt_date3,
                            wt_ccbianhao3: this.ruleForm.wt_ccbianhao3,
                            wt_danwei3: this.ruleForm.wt_danwei3,
                            wt_pihao3: this.ruleForm.wt_pihao3,
                            wt_zhaunghao3: this.ruleForm.wt_zhaunghao3,
                            wt_quyang3: this.ruleForm.wt_quyang3,
                            wt_tiaojian3: this.ruleForm.wt_tiaojian3,
                            wt_shuliang3: this.ruleForm.wt_shuliang3,
                            wt_dbshuliang3: this.ruleForm.wt_dbshuliang3,
                            wt_miaoshu3: this.ruleForm.wt_miaoshu3
                        };
                        this.ruleForm.entrust_content.push(this.arr1, this.arr2, this.arr3);
                        console.log(this.ruleForm.entrust_content);
                        // this.arr1 = [];
                        // this.arr2 = [];
                        // this.arr3 = [];
                        this.loading = true;
                        contract_entrust_add({
                            type: 'material',
                            serial: this.ruleForm.serial,
                            entrust_id: this.ruleForm.entrust_id,
                            entrust_phone: this.ruleForm.entrust_phone,
                            construction_unit: this.ruleForm.construction_unit,
                            project_name: this.ruleForm.project_name,
                            build_unit: this.ruleForm.build_unit,
                            epc_unit: this.ruleForm.epc_unit,
                            witness_unit: this.ruleForm.witness_unit,
                            witness_phone: this.ruleForm.witness_phone,
                            detection_category: this.ruleForm.detection_category,
                            entrust_time: new Date(this.ruleForm.entrust_time) / 1000,
                            entrust_content: this.ruleForm.entrust_content,
                            entrust_project: (this.ruleForm.entrust_project).join(','),
                            entrust_basis: (this.ruleForm.entrust_basis).join(','),
                            attachment: this.ruleForm.attachment,
                            report_number: this.ruleForm.report_number,
                            report_issue: this.ruleForm.report_issue,
                            report_detection: this.ruleForm.report_detection,
                            report_disposal: this.ruleForm.report_disposal,
                            testing_fee: this.ruleForm.testing_fee,
                            declaration: this.ruleForm.declaration,
                            corporate: this.ruleForm.corporate,
                            status: 'notcreate'
                        }).then((res) => {
                            console.log(res);
                            this.loading = false;
                            if (res.data.code == 1) {
                                //   console.log("合同保存成功")
                                this.disabledHetong = true // 合同生成成功禁用提交
                                this.disabledRenwu = false // 合同生成开启生成检测单按钮
                            }
                            this.$message({
                                type: 'success',
                                message: '委托合同保存成功，可以继续操作生成检测任务单'
                            });
                        });
                    } else {
                        // 避免提交重复数据
                        this.arr1 = [];
                        this.arr2 = [];
                        this.arr3 = [];
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        },
        created() {
            this.entrustBasis(); // 检测依据列表
            this.entrustId(); // 委托单位列表
            this.basisProjectChannel(); // 检测项目列表
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .ystatus {
        width: 100%;
        text-align: center;
        color: #847f7f;
    }

    .wstatus {
        width: 100%;
    }

    .el-upload-dragger .el-upload__text {
        font-size: 12px;
        line-height: 24px;
        color: #C3C5CA;
    }

    .upload-demo .el-upload-dragger {
        width: 198px!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/addCailiao.vue